import { render, staticRenderFns } from "./LastTicket.vue?vue&type=template&id=bcd8241c&"
import script from "./LastTicket.vue?vue&type=script&lang=js&"
export * from "./LastTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports